import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { collection, query, where, onSnapshot, orderBy } from "firebase/firestore";
import { db } from "../firebase";
import { useSession } from "../auth.jsx";
import { Eyebrow, TierStamp } from "../components/Bits.jsx";
import { GATES } from "../lib/rubric.js";

const STATE_COPY = {
  draft: "In progress",
  submitted: "Checking",
  returned: "Returned — fix and resubmit",
  queued: "With your Studio Master",
  l2_drafted: "With your Studio Master",
  in_review: "Being marked",
  released: "Marked",
};

export default function Studio() {
  const s = useSession();
  const [briefs, setBriefs] = useState([]);
  const [subs, setSubs] = useState([]);
  const [gates, setGates] = useState([]);

  useEffect(() => onSnapshot(query(collection(db, "briefs"), orderBy("week")), (snap) =>
    setBriefs(snap.docs.map((d) => ({ id: d.id, ...d.data() })))), []);

  useEffect(() => {
    if (!s.user) return;
    return onSnapshot(query(collection(db, "submissions"), where("residentUid", "==", s.user.uid)), (snap) =>
      setSubs(snap.docs.map((d) => ({ id: d.id, ...d.data() }))));
  }, [s.user]);

  useEffect(() => {
    if (!s.user) return;
    return onSnapshot(query(collection(db, "gates"), where("residentUid", "==", s.user.uid)), (snap) =>
      setGates(snap.docs.map((d) => d.data())));
  }, [s.user]);

  const latestFor = (briefId) =>
    subs.filter((x) => x.briefId === briefId).sort((a, b) => (b.attempt ?? 1) - (a.attempt ?? 1))[0];

  const passed = gates.filter((g) => g.status === "passed").length;
  const done = briefs.filter((b) => latestFor(b.id)?.state === "released").length;

  return (
    <div>
      <div className="row between wrapflex">
        <div>
          <Eyebrow>Resident studio</Eyebrow>
          <h1 style={{ fontSize: 24, marginTop: 4 }}>Your 25 briefs — UI, UX, and the craft of shipping</h1>
        </div>
        <div className="mono" style={{ fontSize: 12, textAlign: "right", color: "var(--graphite)" }}>
          <div>{done}/{briefs.length || 25} marked</div>
          <div>{passed}/{Object.keys(GATES).length} gates passed</div>
        </div>
      </div>

      <table style={{ marginTop: 14 }}>
        <thead><tr><th>Brief</th><th>Title</th><th>Tier</th><th>Gate</th><th>Status</th><th></th></tr></thead>
        <tbody>
          {briefs.map((b) => {
            const sub = latestFor(b.id);
            const gid = Object.entries(GATES).find(([, g]) => g.brief === b.id)?.[0];
            const gate = gates.find((g) => g.gateId === gid);
            return (
              <tr key={b.id}>
                <td className="mono">{b.id}</td>
                <td>{b.title}</td>
                <td><TierStamp tier={b.tier} /></td>
                <td>
                  {gid ? (
                    <span className={gate?.status === "passed" ? "pass" : gate?.status === "failed" ? "fail" : ""}>
                      {gid}{gate?.status ? ` · ${gate.status}` : ""}
                    </span>
                  ) : "—"}
                </td>
                <td className={sub?.state === "returned" ? "fail" : ""}>{sub ? STATE_COPY[sub.state] : "Not started"}</td>
                <td><Link to={`/brief/${b.id}`}>{sub ? "Open" : "Start"}</Link></td>
              </tr>
            );
          })}
          {!briefs.length && (
            <tr><td colSpan={6} style={{ color: "var(--graphite)", padding: 18 }}>
              No briefs loaded yet. Your Studio Director seeds the brief book before Matriculation opens.
            </td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
